/**
 * The API stores `code`, `returnLineItemTransition` and `position` as nullable, and validates the
 * transition against a fixed list an empty string is not part of — so a cleared field has to travel
 * as null, which Formik has no way to express.
 *
 * Only fields actually present are touched. A partial payload — the activation toggle sends nothing
 * but `enabled` — must stay partial: PUT populates the existing object, so adding an absent field
 * back as null would erase whatever was configured.
 */
export default function normalizeOptionalFields(values) {
    ['code', 'returnLineItemTransition', 'position'].forEach((field) => {
        if (values[field] === '') {
            values[field] = null;
        }
    });

    // A number input hands back a string; the API expects an integer or nothing.
    if (values.position !== undefined && values.position !== null) {
        values.position = Number(values.position);
    }

    return values;
}
